import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { LoginService } from '../login/shared/login.service';
import { environment } from './../../environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class MorningMeetingService {
    morning_meeting_notif = new Subject();
  
    constructor(
      private https: HttpClient,
      private authenticate: LoginService,
    ) { }
  
    getMorningMeeting(staffid: Number, showAll: Boolean, tz_offset: Number ){
      let headers = new HttpHeaders({
        'Authorization': this.authenticate.getToken(),
        'Content-Type': 'application/json'
      });
      let params = new HttpParams();
      params = params.append('staffId', staffid.toString());
      params = params.append('showAll', showAll.toString());
      params = params.append('tz_offset', tz_offset.toString());
      return this.https.get(`${environment.SERVER_URL}/morning_meeting`, { headers: headers, params: params })
        .pipe(
            catchError(this.handleError),
        );
    }
  
    // downloadAttendanceStatus(from, to, staffid: any): Observable<Blob>  {
    //   let params = new HttpParams();
    //   params = params.append('staff_id', staffid);
    //   params = params.append('from', from);
    //   params = params.append('to', to);
    //   let headers = new HttpHeaders({
    //     'Authorization': this.authenticate.getToken(),
    //     'Content-Type': 'application/json'
    //   })
  
    //   return this.https.get(`${environment.SERVER_URL}/attendance_status/download`, { headers: headers, params: params, responseType: 'blob' })
    //     .pipe(
    //       catchError(err => throwError(err))
    //     );
    // }

    updateMorningMeeting(id: string, comment: string, absent: boolean | null) {
      let headers = new HttpHeaders({
        'Authorization': this.authenticate.getToken(),
        'Content-Type': 'application/json'
      });
      let body = {
        id: id,
        comment: comment, 
        absent: absent
      }
      
      return this.https.put(`${environment.SERVER_URL}/morning_meeting`, body, { headers: headers })
        .pipe(
            catchError(this.handleError),
        );
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
            const body = error || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
  }

  